import React from 'react';
import styled from 'styled-components';
import { CDN_ASSET_URL } from '../../services/AssetsService';

const FPTLogo = styled.img`
  display: block;
  max-height: 5vh;
  min-height: 25px;
  margin: 4vh auto 12px;
`;

const LogoPanel = function () {
  return (
    <FPTLogo src={CDN_ASSET_URL + '/logos/fpt_logo_splashscreen.png'} />
  )
}

export default LogoPanel
